import type { Ref } from 'vue';
import { computed, unref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getApi } from './api';
import type { GeofenceRemovalSuggestion } from './getAccountGeofenceRemovalSuggestions';

export default function getAccountGeofenceRemovalSuggestion(
  accountId: Ref<number | null | undefined> | number | null | undefined,
  suggestionId: Ref<string | null | undefined> | string | null | undefined,
) {
  const query = useQuery({
    queryKey: [
      'geofence-removal-suggestion',
      () => unref(accountId),
      () => unref(suggestionId),
    ],
    queryFn: async () => {
      const aid = unref(accountId);
      const sid = unref(suggestionId);
      if (aid == null || aid === 0 || !sid) {
        return null as GeofenceRemovalSuggestion | null;
      }
      const { api, baseURL } = getApi();
      const res = await api.get(
        `api/v2/accounts/${aid}/geofence-removal-suggestions/${sid}`,
        { baseURL, useOriginalToken: true },
      );
      return (res.data?.data ?? null) as GeofenceRemovalSuggestion | null;
    },
    enabled: () => {
      const aid = unref(accountId);
      const sid = unref(suggestionId);
      return aid != null && aid !== 0 && !!sid;
    },
    staleTime: 60 * 1000,
  });

  const suggestion = computed<GeofenceRemovalSuggestion | null>(
    () => query.data.value ?? null,
  );

  return {
    ...query,
    suggestion,
  };
}
